import { render, staticRenderFns } from "./ShiftsTemplateIndex.vue?vue&type=template&id=7fd8dc52&"
import script from "./ShiftsTemplateIndex.vue?vue&type=script&lang=js&"
export * from "./ShiftsTemplateIndex.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports